import { FC } from "react";

import { useFormContext, useWatch } from "react-hook-form";

import { useRateContext } from "../../../Context/RateContext";
import { useRateFieldName } from "../../../hooks/useRateFieldName";
import { PayWhatYouCanAmountFields } from "../../../RateFields/PayWhatYouCanAmountFields/PayWhatYouCanAmountFields";
import { RateOptionToggleRow } from "../RateOptionToggleRow";

import { AmplitudeEvents } from "@/common/constants/amplitude";
import { useAmplitude } from "@/common/hooks/amplitude/useAmplitude";
import { useTranslate } from "@/common/hooks/useTranslate";
import { Amount } from "@/icons/outlined";
import { StepTicketsFormData } from "@/features/LiveFormEditor/Steps/StepTickets/types";

export const PayWhatYouCanRow: FC = () => {
  const { t } = useTranslate();
  const { logAmplitudeEvent } = useAmplitude();
  const { hasExistingPayments, formCategory, isEditing, isOnboarding } = useRateContext();
  const { control, setValue, clearErrors } = useFormContext<StepTicketsFormData>();

  const fieldName = useRateFieldName("isPayWhatYouCan");
  const receiptEligibleAmountField = useRateFieldName("receiptEligibleAmount");
  const isChecked = useWatch({ control, name: fieldName });

  const handleToggle = (checked: boolean) => {
    setValue(fieldName, checked, { shouldDirty: true });
    if (checked) {
      clearErrors(receiptEligibleAmountField);
    }
    logAmplitudeEvent(AmplitudeEvents.TicketOptionToggled, {
      option: "pay_what_you_can",
      enabled: checked,
      entry_point: "manual",
      form_type: formCategory,
      is_liveform: true,
      isEditing,
      isOnboarding,
    });
  };

  return (
    <RateOptionToggleRow
      optionKey="payWhatYouCan"
      checked={Boolean(isChecked)}
      onToggle={handleToggle}
      disabled={hasExistingPayments}
      disabledTooltip={t("dashboard", "ticketing.payWhatYouCanDisabledExistingPayments")}
      icon={<Amount />}
      label={t("dashboard", "ticketing.rateOption.payWhatYouCan")}
      tooltip={t("dashboard", "ticketing.isPayWhatYouCanInformation")}
      inlineConfig={isChecked ? <PayWhatYouCanAmountFields variant="inline" /> : undefined}
    />
  );
};
